/**
 * FAIR Dialog — Figma 1:8055 / 1:8062
 */

export const FAIR_DIALOG_CONTENT_TYPES = ['text'] as const
export type FairDialogContentType = (typeof FAIR_DIALOG_CONTENT_TYPES)[number]

export const FAIR_DIALOG_DEFAULT_WIDTH = '700px'
